export function formatCount(value: number): string {
  if (value >= 10000) {
    const num = value / 10000;
    return `${num >= 10 ? num.toFixed(0) : num.toFixed(1)}万`;
  }
  if (value >= 1000) {
    return `${(value / 1000).toFixed(1)}k`;
  }
  return String(value);
}

export const categoryStyles: Record<
  string,
  { chip: string; dot: string; soft: string; text: string }
> = {
  entertainment: {
    chip: "bg-primary-100 text-primary-800 border border-primary-200",
    dot: "bg-primary-500",
    soft: "bg-primary-50",
    text: "text-primary-700",
  },
  influencer: {
    chip: "bg-accent-100 text-accent-900 border border-accent-200",
    dot: "bg-accent-500",
    soft: "bg-accent-50",
    text: "text-accent-700",
  },
  emotion: {
    chip: "bg-secondary-100 text-secondary-900 border border-secondary-200",
    dot: "bg-secondary-500",
    soft: "bg-secondary-50",
    text: "text-secondary-700",
  },
  workplace: {
    chip: "bg-background-200 text-foreground-800 border border-background-300",
    dot: "bg-foreground-400",
    soft: "bg-background-100",
    text: "text-foreground-700",
  },
  tech: {
    chip: "bg-secondary-200 text-secondary-900 border border-secondary-300",
    dot: "bg-secondary-600",
    soft: "bg-secondary-100",
    text: "text-secondary-800",
  },
  variety: {
    chip: "bg-primary-50 text-primary-700 border border-primary-100",
    dot: "bg-primary-400",
    soft: "bg-primary-50",
    text: "text-primary-600",
  },
};

export function getCategoryStyle(slug: string) {
  return categoryStyles[slug] ?? categoryStyles.workplace;
}

export const SITE_URL = "https://lcsxjtg.cn";
export const SITE_NAME = "瓜友会网";
export const SITE_EMAIL = "hi@guayouhui-mail.com";